import { Typography } from 'design-system/src/components/Typography/Typography';
import styled from 'styled-components';

const StyledStructuredTaskSmallPrint = styled(Typography)<{ $marginTop?: string }>`
  margin-top: ${({ $marginTop }) => $marginTop};
`;

export type StructuredTaskSmallPrintProps = {
  marginTop?: string;
};

/**
 * A notice that appears at the bottom of strcutured task pages regarding the prescribing licensed healthcare provider's
 * responsibility for the accuracy of the information.
 */
export const StructuredTaskSmallPrint = ({ marginTop = '16px' }: StructuredTaskSmallPrintProps) => {
  return (
    <StyledStructuredTaskSmallPrint $marginTop={marginTop} styledAs="bodyExtraExtraSmallDMSans">
      Please note that the prescribing licensed healthcare provider is responsible for ensuring that all the information
      provided on the prior authorization, appeal letter, and/or letter of medical necessity is accurate with respect to
      the patient. Tandem populates forms and letters based on information that you provide in the patient's medical
      record or directly, and Tandem is not responsible for the truth and accuracy of information provided by you.
    </StyledStructuredTaskSmallPrint>
  );
};

export default StructuredTaskSmallPrint;
